import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RegistrationGuard implements CanActivate {
  constructor(private readonly authService: AuthService, private readonly router: Router) {}

  canActivate(): Observable<boolean> {
    return this.authService.fetchUserFromServer().pipe(
      first(),
      map((user) => {
        if (user) {
          const hasCompleted = user?.customFields?.hasCompletedRegistration ?? false;

          if (!hasCompleted) {
            this.authService.showDialog();
          }
          return true;
        } else {
          this.authService.cleanStorage();
          this.router.navigate(['/']);
          return false;
        }
      }),
      catchError((error) => {
        //console.error('[RegistrationGuard] Errore nella guardia:', error);
        this.authService.cleanStorage();
        this.router.navigate(['/']);
        return of(false);
      }),
    );
  }
}
